// List of domains to block
const blockedDomains = [
  "acdn.goldendev.win"
];

// Intercept script creation and block setting `src`
const originalCreateElement = document.createElement;

document.createElement = function (tagName) {
  if (tagName.toLowerCase() === 'script') {
    const script = originalCreateElement.call(this, tagName);

    Object.defineProperty(script, 'src', {
      set(value) {
        try {
          if (typeof value === "string") {
            if (blockedDomains.some(domain => value.includes(domain))) {
              console.warn('[Blocked script injection]:', value);
              return;
            }
          }
          this.setAttribute('src', value);
        } catch(e) {
          console.error(value, e);
        }
      },
      get() {
        return this.getAttribute('src');
      },
      configurable: true
    });

    return script;
  }

  return originalCreateElement.call(this, tagName);
};

// Also remove any bad scripts already added to DOM
const scriptBlockerObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (
        node.tagName === 'SCRIPT' &&
        node.src &&
        typeof node.src === 'string' &&
        blockedDomains.some(domain => node.src.includes(domain))
      ) {
        console.warn('[Removed already-inserted script]:', node.src);
        node.remove();
      }
    }
  }
});

scriptBlockerObserver.observe(document.documentElement, {
  childList: true,
  subtree: true,
});
